import _ from 'lodash';
import { service } from './service';
import { SORT_ORDER } from '@/resources/Constants'
import {
    getGridPagingParams, mapGridPagingState,
} from '../../../shared/utils';
import { IRX_ELIGIBLE_OPTIONS } from '../../../shared/constants';

const DEFAULT_SORT_ORDER = SORT_ORDER.ASC;



const state = {
    ndcDetailsPaging: {
        ...getGridPagingParams(DEFAULT_SORT_ORDER, 'brand'),
        filters: {
            brand: null,
            iRxEligible: IRX_ELIGIBLE_OPTIONS.ALL,
            ndC11: null
        }
    },
    ndcDetailsRecords: [],
};

const getters = {

};

const actions = {

    async getNDCsDetailsRecords({ commit, state },
        {
            pageNumber = state.ndcDetailsPaging.pageNumber,
            pageSize = state.ndcDetailsPaging.pageSize,
            sortBy = state.ndcDetailsPaging.sortBy,
            sortOrder = state.ndcDetailsPaging.sortOrder,
            filters = state.ndcDetailsPaging.filters,
        } = {}) {

        const results = await service.getNDCsDetailsRecords(
            pageNumber,
            pageSize,
            sortOrder,
            sortBy,
            filters
        );

        commit('setNDCsDetailsRecords', results);
    },

};

const mutations = {


    setNDCsDetailsRecords(state, payload) {
        const pagingData = payload && payload.paging;

        state.ndcDetailsRecords = payload && payload.items;

        if (pagingData) {
            state.ndcDetailsPaging = mapGridPagingState(
                state.ndcDetailsPaging,
                pagingData
            );
        }
    },

};

const ndcDetails = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default ndcDetails;
